import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import { ValidationHelper } from "@/Common/Helpers/ValidationHelper";
import { BillingPaymentMethod } from "@/Common/Models/UI/BillingPaymentMethod";
import { PrivateBill_BilledTo } from "@/Common/Models/UI/Enums";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { IPatientHistoryPrivateBillEditProps, PrivateBillEditControl } from "@/Patient/Components/History/PrivateBillEditControl";

import "./PrivateBillEditPopup.css";

interface IMedicalNotePrivateBillEditProps extends IPatientHistoryPrivateBillEditProps {
    OnSaveOperation: number;
    OnPrintAndSaveOperation: number;
    OnCloseBillOperation: number;
}

interface PrivateBillEditPopupState {
    isFormValid: boolean;
}

class PrivateBillEditPopup extends React.Component<IMedicalNotePrivateBillEditProps, PrivateBillEditPopupState> {
    private id = "privatebilleditpopup";

    constructor(props: IMedicalNotePrivateBillEditProps) {
        super(props);

        this.state = {
            isFormValid: false
        };

        this.setIsFormValid = this.setIsFormValid.bind(this);
    }

    public componentDidMount(): void {
        const elem = $(`#${this.id}`);
        const cnt = document.body;
        const dragOptions = {
            containment: cnt,
            handle: ".p-header"
        };
        elem.draggable(dragOptions);

        if (this.props.Model.get("IsEditBill") === false && this.props.BillableServicesModel?.length === 0)
            LocalEvent.Dispatch(LocalPatientOperations.History.LoadDummyServices);

        overlayStore.showOverlay("global-overlay");

        $(window).trigger("resize");
    }

    private setIsFormValid(value: boolean): void {
        this.setState({ isFormValid: value });
        this.props.onIsFormValidChange(value);
    }
    public componentWillUnmount(): void {
        overlayStore.hideOverlay("global-overlay");

        const elem = $("#" + this.id);
        elem.draggable("destroy");
    }

    public render(): JSX.Element {
        let canSave = this.state.isFormValid;

        const regexPattern = new ValidationHelper()
            .getPhoneNumberValidationRule(cacheStore.GetDefaultCountryForActiveSite().LookupID, null)
            .ValidationRegexPattern;

        const isFaxNumberValid = ValidationHelper.isExactMatch(this.props.Model.get("SelectedBillRecipientDetails")?.RecipientFaxNumber, new RegExp(regexPattern));

        const isFaxDisabled = !isFaxNumberValid || !canSave || IsNullOrWhiteSpace(this.props.Model.get("SelectedBillRecipientDetails")?.RecipientName);
        const isFaxShown: boolean = this.props.Model.get("SelectedBillBilledTo") == PrivateBill_BilledTo.ThirdParty;

        const isPrintDisabled = (!canSave)
            || (this.props.Model.get("SelectedBillBilledTo") == PrivateBill_BilledTo.ThirdParty
                && IsNullOrWhiteSpace(this.props.Model.get("SelectedBillRecipientDetails")?.RecipientName));
        const isPrintVisible = cacheStore.ClinicSettings.EnablePrivateBillRecipient;

        const canClose = !cacheStore.ClinicSettings.EnablePrivateBillRecipient
            || (cacheStore.ClinicSettings.EnablePrivateBillRecipient
            && this.props.Model.get("SelectedPaymentMethod") != BillingPaymentMethod.Payable);

        return (
            <div id={this.id} onClick={this.stopPropagation.bind(this)} className="portfolio request-popup main-popup">
                <div className="row p-header no-bottom-margin" style={{ marginLeft: "0px", marginRight: "0px" }}>
                    <div className="col-lg-12">
                        <a className="close" onClick={() => sessionStore.dispatch(this.props.OnCloseOperation)} aria-label="Close">×</a>
                        <h3 className="uppercase">{cacheStore.GetString("PrivateBillingLabel")}</h3>
                    </div>
                </div>

                <PrivateBillEditControl
                    Model={this.props.Model}
                    BillableServicesModel={this.props.BillableServicesModel}
                    TodayClickedOp={this.props.TodayClickedOp}
                    DateOfVisit_Set={this.props.DateOfVisit_Set}
                    SelectClinician={this.props.SelectClinician}
                    DidMountOp={this.props.DidMountOp}
                    SiteSelectedOp={this.props.SiteSelectedOp}
                    CostCenterChangedOp={this.props.CostCenterChangedOp}
                    PaymentMethodChangedOp={this.props.PaymentMethodChangedOp}
                    DiscountChangedOp={this.props.DiscountChangedOp}
                    DiscountTypeChangeOp={this.props.DiscountTypeChangeOp}
                    ClearOp={this.props.ClearOp}
                    SelectService={this.props.SelectService}
                    PriceChange={this.props.PriceChange}
                    QuantityChanged={this.props.QuantityChanged}
                    ChangeGST={this.props.ChangeGST}
                    ChangeQST={this.props.ChangeQST}
                    ChangeHST={this.props.ChangeHST}
                    ChangeGenericTax={this.props.ChangeGenericTax}
                    RemoveService={this.props.RemoveService}
                    NotesChangeOp={this.props.NotesChangeOp}
                    LockProviderOp={this.props.LockProviderOp}
                    ChangeRecipientDetailsOp={this.props.ChangeRecipientDetailsOp}
                    BilledToChangeOp={this.props.BilledToChangeOp}
                    OnCancelBillOp={this.props.OnCancelBillOp}
                    DoNotRenderAsScrollable={this.props.DoNotRenderAsScrollable}
                    onIsFormValidChange={this.setIsFormValid}
                />

                <div className="row">
                    <div className="col-lg-12">
                        <div className="p-footer">
                            <div className="row">
                                <div className="col-lg-12 text-right">
                                    <ButtonControl
                                        className="btn btn-default push-right-5"
                                        onClick={() => sessionStore.dispatch(this.props.OnCloseOperation)}
                                        label={cacheStore.GetString("CancelLabel")}
                                        dataCy="privateBillEdit-cancel"
                                    />
                                    <ButtonControl
                                        disabled={!canSave}
                                        className="btn btn-primary push-right-5"
                                        onClick={() => sessionStore.dispatch(this.props.OnSaveOperation)}
                                        label={cacheStore.GetString("SaveLabel")}
                                        dataCy="privateBillEdit-save"
                                    />
                                    {isPrintVisible && (
                                        <ButtonControl
                                            className="btn btn-primary push-right-5"
                                            disabled={isPrintDisabled}
                                            onClick={() => sessionStore.dispatch(LocalPatientOperations.MedicalNote.PrivateBill_SaveAndPrint)}
                                            label={cacheStore.GetString("PrintLabel")}
                                        />
                                    )}
                                    {isFaxShown && (
                                        <ButtonControl
                                            className="btn btn-primary push-right-5"
                                            disabled={isFaxDisabled}
                                            onClick={() => sessionStore.dispatch(LocalPatientOperations.MedicalNote.PrivateBill_SaveAndFax)}
                                            label={cacheStore.GetString("FaxLabel")}
                                        />
                                    )}
                                    <ButtonControl
                                        className="btn btn-primary push-right-5"
                                        disabled={!canClose}
                                        onClick={this.onCloseBillClick}
                                        label={cacheStore.GetString("CloseLabel")}
                                        dataCy="privateBillEdit-close"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private stopPropagation(e: React.MouseEvent): void {
        e.stopPropagation();
    }

    private onCloseBillClick(): void {
        sessionStore.showPopup({
            title: cacheStore.GetString("CloseSelectedBillLabel"),
            content: cacheStore.GetString("CloseSelectedBillMessageLabel"),
            showCancel: true,

            okLabel: cacheStore.GetString("CloseLabel"),
            okAction: () => sessionStore.dispatch(LocalPatientOperations.MedicalNote.PrivateBillWarning_Save, { IsFromClose: true }),

            altButtonLabel: cacheStore.GetString("CloseAndPrintLabel"),
            altButtonAction: () => sessionStore.dispatch(LocalPatientOperations.MedicalNote.PrivateBillWarning_SaveAndPrint, { IsFromClose: true })
        });
    }
}

export { PrivateBillEditPopup };
